<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text>
        <strong>こちらの内容で実行します。よろしいですか？</strong>
        <v-container fluid class="pl-0">
          <v-row class="mb-4">
            <v-col>
              <app-label-group
                :label="
                  lineCategory === 'AC' ? 'IPsec回線番号' : 'VNコネクト番号'
                "
                :value="number"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <app-label-group
                label="実行処理"
                :value="$filter.enumTo(ifStatus, 'cloudVn_ifStatus')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" @click="ok">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  LineCategory,
  PutIfStateRequest,
} from "@/apis/NwOperationToolApi";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "IFModify",
  components: { AppLabelGroup },
  props: {
    /** 参照回線種別 */
    lineCategory: {
      type: String as PropType<LineCategory>,
      required: true,
    },
    /** W番号/X番号 */
    number: {
      type: String as PropType<string>,
      required: true,
    },
    /** IF状態 */
    ifStatus: {
      type: String as PropType<PutIfStateRequest["ifStatus"]>,
      required: true,
    },
  },
});
</script>
